import { useEffect, useState, Fragment } from "react";

import { useVenueQuery } from "../../../services/venuesApi";
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useBlackListQuery, useAddBlackListMutation } from '../../../services/blackListApi';
import { useEditUserMutation } from '../../../services/accountsApi';
import Button from '@mui/material/Button';
import { useNotification } from '../../../context/NotificationContext';

import CircularProgress from "@mui/material/CircularProgress";

import Switch from "@mui/material/Switch";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import CustomSwitch from "../../../components/CustomSwitch";

import { makeStyles } from '@material-ui/core/styles';
import { Divider } from "@mui/material";

//A: this is for remove the arrows key in the input number
const useStyles = makeStyles({
  input: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
});


/**
 * If the input is not a positive integer, return false. Otherwise, return true.
 * @param inputText - The text that the user has entered into the input field.
 * @returns A boolean value.
 */
function isValidNumber(inputText) {
  let inputTextParsed = Number(inputText);
  if (inputText == "" || isNaN(inputTextParsed) || !Number.isInteger(inputTextParsed) || inputTextParsed <= 0) {
    return false;
  }
  return true;
}

const blackListTypes = {
  "Venue": "Venue",
  "OnlyTmOrLn": "OnlyTmOrLn",
  "MinDayMaxDay": "MinDayMaxDay"
}

function MinMaxDateBlackList(props) {
  const { formErrors, setFormErrors, formState, setFormState, getMinMaxDateBlackList } = props;

  const onChangeInputHandler = (event) => {
    const { name, value } = event.target;
    setFormState({ ...formState, [name]: value });
  };

  const classes = useStyles();

  const switchHandleChangle = () => {
    if (!formState.minMaxDateBlackListEnable == false) {
      //A: if the swith is disable, then we need to restore the old values and delete all errors messages
      let oldValues = getMinMaxDateBlackList();
      setFormState({ ...formState, minDays: oldValues[0] || "", maxDays: oldValues[1] || "", minMaxDateBlackListEnable: !formState.minMaxDateBlackListEnable });
      setFormErrors(prev => ({ ...prev, minMaxDateBlackList: "" }));
    } else {
      setFormState({ ...formState, minMaxDateBlackListEnable: !formState.minMaxDateBlackListEnable });
    }
  }

  const label = { inputProps: { "aria-label": "controlled" }, color: "success" };

  const TextWithOrangeColor = ({ text }) => <h5 style={{ margin: '0 0 0.5em 0' }} >{text}</h5>


  return (
    <>

      <Grid container justifyContent="space-between" alignItems="center" margin="0 0 1em 0">
        <Grid item >
          <h4 style={{ color: 'var(--orange)' }} >Do not distribute Jobs if</h4>
        </Grid>
        <Grid item >
          <Box >
            <CustomSwitch {...label} checked={formState.minMaxDateBlackListEnable} onChange={switchHandleChangle} />
          </Box>
        </Grid>
      </Grid>


      <Box  >
        <Grid container spacing={0} sx={{ display: 'flex', justifyContent: 'space-between', width: '50%' }} >

          <Grid sx={{ display: 'flex', alignItems: 'center' }} >

            <Grid item xs={2}>
              <TextWithOrangeColor text="<" />
            </Grid>

            <Grid item xs={6}>
              <TextField
                style={formState.minMaxDateBlackListEnable ? { width: "55px", backgroundColor: 'white' } : { width: "55px" }}
                size="small"
                className={classes.input}
                variant="outlined"

                value={formState.minDays} name="minDays"
                onChange={onChangeInputHandler}
                disabled={!formState.minMaxDateBlackListEnable}
                type="number"
              />
            </Grid>

            <Grid item xs={6}>
              <p style={{ whiteSpace: 'nowrap' }} >
                Days to Event
              </p>
            </Grid>

          </Grid>

          <Grid sx={{ display: 'flex', alignItems: 'center' }} >

            <Grid item xs={2}>
              <TextWithOrangeColor text=">" />
            </Grid>

            <Grid item xs={6}>
              <TextField
                size="small"
                className={classes.input}
                type="number"
                variant="outlined"
                style={formState.minMaxDateBlackListEnable ? { width: "55px", backgroundColor: 'white' } : { width: "55px" }}
                value={formState.maxDays} name="maxDays"
                onChange={onChangeInputHandler}
                disabled={!formState.minMaxDateBlackListEnable}
              />
            </Grid>
            <Grid item xs={6}>
              <p style={{ whiteSpace: 'nowrap' }}>
                Days to Event
              </p>
            </Grid>

          </Grid>

        </Grid>
      </Box>

      <p style={{ color: 'red', marginTop: '8px' }}>{formErrors.minMaxDateBlackList}</p>

    </>
  )
}

function MaxJobsUntilInelegible(props) {
  const { formErrors, setFormErrors, formState, setFormState, getMinMaxDateBlackList, user } = props;

  const onChangeInputHandler = (event) => {
    const { name, value } = event.target;
    setFormState({ ...formState, [name]: value });
  };

  const classes = useStyles();

  const switchHandleChangle = () => {
    if (!formState.isMaxJobsUntilIneligibleActive == false) {
      //A: if the swith is disable, then we need to restore the old values and delete all errors messages
      let oldValue = user.maxJobsUntilIneligible;
      setFormState({ ...formState, maxJobsUntilIneligible: oldValue || "", isMaxJobsUntilIneligibleActive: !formState.isMaxJobsUntilIneligibleActive });
      setFormErrors(prev => ({ ...prev, maxJobsUntilIneligible: "" }));
    } else {
      setFormState({ ...formState, isMaxJobsUntilIneligibleActive: !formState.isMaxJobsUntilIneligibleActive });
    }
  }

  const label = { inputProps: { "aria-label": "controlled" }, color: "success" };

  const TextWithOrangeColor = ({ text }) => <h5 style={{ margin: '0 0 0.5em 0', color: 'var(--orange)' }} >{text}</h5>


  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center" margin="0 0 1em 0">
        <Grid item display="flex" alignItems="center" >
          <Grid item margin="0 1em 0 0">
            <h4 style={{ color: 'var(--orange)', whiteSpace:'nowrap' }} >Max Jobs until flipped to ineligible</h4>
          </Grid>

          <Grid item xs={3}>
            <TextField
              style={formState.isMaxJobsUntilIneligibleActive ? { width: "55px", backgroundColor: 'white' } : { width: "55px" }}
              size="small"
              className={classes.input}
              variant="outlined"
              value={formState.maxJobsUntilIneligible} name="maxJobsUntilIneligible"
              onChange={onChangeInputHandler}
              disabled={!formState.isMaxJobsUntilIneligibleActive}
              type="number"
            />
          </Grid>

        </Grid>

        <Grid item >
          <CustomSwitch {...label} checked={formState.isMaxJobsUntilIneligibleActive} onChange={switchHandleChangle} />
        </Grid>

      </Grid>

      <p style={{ color: 'red', marginTop: '8px' }}>{formErrors.maxJobsUntilIneligibleErros}</p>

    </>
  )
}

export default function BlackList({ user }) {

  const { showNotification } = useNotification();

  let urlParams = "?userId=" + user.id;
  const {
    data: blackList,
    isSuccess: isBlackListSuccess,
    isLoading: isBlackListLoading,
    isError: isBlackListError,
    error: blackListError } = useBlackListQuery(urlParams);

  const [
    updateBL,
    {
      data: updateResult,
      isLoading: updatingBL,
      error: updateBLError,
      isSuccess: updateBLIsOk,
      isError: updateBLIsError,
    }
  ] = useAddBlackListMutation();

  const [updateUser, { data: updateResultUser, isLoading: updatingUser, error: updateErrorUser, isSuccess: updateIsOkUser, isError: updateIsErrorUser, }] = useEditUserMutation();

  const { data: venues, isSuccess: isVenueSuccess, isLoading, isError, error } = useVenueQuery();

  const [venuesBlacklisted, setVenuesBlacklisted] = useState(null);

  const [onlyTmOrLn, setOnlyTmOrLn] = useState(false);

  const [forceFCFS, setForceFCFS] = useState(false);

  const [formState, setFormState] = useState({
    minDays: "",
    maxDays: "",
    minMaxDateBlackListEnable: false,
    maxJobsUntilIneligible: "",
    isMaxJobsUntilIneligibleActive: false,

  });

  const [formErrors, setFormErrors] = useState({ minMaxDateBlackList: "" });

  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    limit: 2500,
  });

  useEffect(() => {
    if (isBlackListSuccess && isVenueSuccess) {
      let venuesBlacklisted = [];
      blackList.forEach(blackListedVenue => {
        if (blackListedVenue.elementType !== blackListTypes.Venue) return;
        let found = venues.find(venue => parseInt(venue.venueId) === parseInt(blackListedVenue.elementValue));
        venuesBlacklisted.push(found);
      });
      setVenuesBlacklisted(venuesBlacklisted);
    }
  }, [isBlackListSuccess, isVenueSuccess]);

  useEffect(() => {
    let onlyTmOrLn = false;
    if (!blackList) return onlyTmOrLn;
    blackList.forEach(item => {
      if (item.elementType === blackListTypes.OnlyTmOrLn) {
        console.log(item);
        onlyTmOrLn = item.elementValue === "true";
      }
    });
    setOnlyTmOrLn(onlyTmOrLn);
  }, [isBlackListSuccess])

  useEffect(() => {
    if (user && user.id) {
      setForceFCFS(user.forceFCFS);
      setFormState(prev => ({ ...prev, maxJobsUntilIneligible: user.maxJobsUntilIneligible || "", isMaxJobsUntilIneligibleActive: user.isMaxJobsUntilIneligibleActive ? true : false }));
    }
  }, [user]);


  function getMinMaxDateBlackList() {
    console.log(blackList)
    if (!blackList) return [];
    let res = [];
    blackList.forEach(item => {
      if (item.elementType === blackListTypes.MinDayMaxDay) {
        console.log(item);
        //A: example: "-12-true"
        let splitted = item.elementValue.split("-");
        console.log(splitted)
        let minDays = splitted[0];
        let maxDays = splitted[1];
        res = [minDays, maxDays];
      }
    });
    return res;
  }

  useEffect(() => {
    if (!blackList) return;
    blackList.forEach(item => {
      if (item.elementType === blackListTypes.MinDayMaxDay) {
        console.log(item);
        //A: example: "-12-true"
        let splitted = item.elementValue.split("-");
        console.log(splitted)
        let minDays = splitted[0] || "";
        let maxDays = splitted[1] || "";
        let minMaxDateBlackListEnable = splitted[2] === "true";
        setFormState(prev => ({ ...prev, minDays, maxDays, minMaxDateBlackListEnable }));
        return;
      }
    });
  }, [isBlackListSuccess])

  useEffect(() => {
    if (updateBLIsError || updateBLIsOk) {
      showNotification(updateBLIsError || updateErrorUser ? "Error Updating BlackList" : "BlackList Updated", updateBLIsError || updateErrorUser ? "error" : "success");
    }
  }, [updateBLIsError, updateBLIsOk])

  function createVenuesBlackList() {
    console.table(venuesBlacklisted);
    let venuesIds = venuesBlacklisted.map(venue => venue.venueId);
    let newBlackList = {
      "userId": user.id,
      "elementType": "Venue",
      "items": venuesIds
    }
    return newBlackList;
  }

  function createOnlyTmBlackList() {
    return {
      "userId": user.id,
      "elementType": "OnlyTmOrLn",
      "items": [onlyTmOrLn]
    }
  }

  function createMinMaxDateBlackList() {
    return {
      "userId": user.id,
      "elementType": "MinDayMaxDay",
      "items": [`${formState.minDays || ""}-${formState.maxDays || ""}-${formState.minMaxDateBlackListEnable}`]
    }
  }

  const bothInputsAreEmpty = () => {
    return formState.minDays == "" && formState.maxDays == "";
  }

  function isValidaInput(value) {
    return value != "" && isValidNumber(value)
  }

  function existsErrorsInForm() {

    let errors = formErrors.minMaxDateBlackList;
    console.log("formState.minDays: ", formState.minDays + " formState.maxDays: ", formState.maxDays + " bothInputsAreEmpty: ", bothInputsAreEmpty() + "");
    if (bothInputsAreEmpty() && formState.minMaxDateBlackListEnable) {
      errors = "At least one field must be filled";
    }
    else if ((formState.minDays != "" && !isValidaInput(formState.minDays)) || (formState.maxDays != "" && !isValidaInput(formState.maxDays))) {
      errors = "Fields must be positive integers";
    }
    else if (formState.maxDays != "" && formState.minDays != "" && parseInt(formState.minDays) > parseInt(formState.maxDays)) {
      errors = "Min days must be less than max days";
    }
    else {
      errors = ""
    }
    let maxJobsUntilIneligibleErros="";
    if(formState.isMaxJobsUntilIneligibleActive && !isValidNumber(formState.maxJobsUntilIneligible)){
      maxJobsUntilIneligibleErros = "Field must be a positive integer";
    }
    setFormErrors(prev => ({ ...prev, minMaxDateBlackList: errors, maxJobsUntilIneligibleErros }));
    return (errors != "" || maxJobsUntilIneligibleErros != "");
  }

  async function handleUpdateBlackList() {
    if (existsErrorsInForm()) return;
    let newBlackList = [
      createVenuesBlackList(),
      createOnlyTmBlackList(),
      createMinMaxDateBlackList()
    ]

    let userUpdated = {
      id: user.id,
      forceFCFS: forceFCFS,
      maxJobsUntilIneligible: formState.maxJobsUntilIneligible,
      isMaxJobsUntilIneligibleActive: formState.isMaxJobsUntilIneligibleActive
    }
    console.log("updating Blacklist: ", newBlackList);
    console.log("updating user: ", userUpdated);
    await updateBL(newBlackList).unwrap();
    await updateUser(userUpdated).unwrap();
  }

  function thereAreFormErrors() {
    return Object.values(formErrors).some(error => error !== "");
  }

  const handleChange = (event, value) => setVenuesBlacklisted(value);

  const label = { inputProps: { "aria-label": "controlled" }, color: "success" };

  return (
    <Fragment>
      <h4 style={{ margin: '0 0 0.25em 0', color: 'var(--orange)' }} >Blacklisted Venues </h4>
      {isLoading && <p>Loading...</p>}
      {isVenueSuccess && venuesBlacklisted !== null &&
        <Autocomplete
          disablePortal
          multiple
          id="venuesList"
          onChange={handleChange}
          defaultValue={venuesBlacklisted}
          options={venues}
          getOptionLabel={(option) => option.venueName}
          sx={{ width: '100%', margin: '0 0 1.5em 0' }}
          filterOptions={filterOptions}
          renderInput={(params) => <TextField {...params} />}
        />
      }

      <Divider sx={{ margin: '0 0 1em 0' }} />

      <Grid container justifyContent="space-between" alignItems="center" margin="0 0 1em 0">
        <Grid item  >
          <h4 style={{ color: 'var(--orange)' }} >Only TicketMaster or LiveNation Events</h4>
        </Grid>
        <Grid item >
          <Box >
            <CustomSwitch {...label} checked={onlyTmOrLn} onChange={() => setOnlyTmOrLn(prev => !prev)} />
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ margin: '0 0 1em 0' }} />

      <MinMaxDateBlackList
        formState={formState}
        setFormState={setFormState}
        formErrors={formErrors}
        setFormErrors={setFormErrors}
        getMinMaxDateBlackList={getMinMaxDateBlackList}
      />

         {/* FORCE FIRST COME FIRST SERVE Switch */}
         <Grid container justifyContent="space-between" alignItems="center" margin="0 0 1em 0">
        <Grid item  >
          <h4 style={{ color: 'var(--orange)' }} >Allow FCFS for this user</h4>
        </Grid>
        <Grid item >
          <Box >
            <CustomSwitch {...label} checked={forceFCFS} onChange={() => setForceFCFS(prev => !prev)} />
          </Box>
        </Grid>
      </Grid>

      <MaxJobsUntilInelegible
        formState={formState}
        setFormState={setFormState}
        formErrors={formErrors}
        setFormErrors={setFormErrors}
        getMinMaxDateBlackList={getMinMaxDateBlackList}
        user={user}
      />   

      <div style={{ witdh: '100%', display: 'flex', justifyContent: 'flex-end', margin: '2em 0 0 0' }} >
        <Button
          variant="contained"
          style={{ width: "100px" }}
          disabled={(updatingBL || isLoading)}
          onClick={handleUpdateBlackList}>
          {(updatingBL) ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Save"}
        </Button>

      </div>

    </Fragment>
  )
}